module.exports = __webpack_public_path__ + "img/contact-banner.a4317dd9.svg";